export default "__VITE_ASSET__Cb52GYsV__"